import React, { FC } from 'react'

import { Text } from '@interco/inter-ui/components/Text'

import { TDontDistubMessageView } from '../types/DontDistubMessage.types'

export const DontDistubMessageView: FC<TDontDistubMessageView> = ({
  contentPartOne,
  contentPartTwo,
  site,
}) => (
  <section>
    <Text variant="body-3" color="typography">
      {contentPartOne}
      <strong> {site} </strong>
      {contentPartTwo}
    </Text>
  </section>
)
